import {
  CURRENT_BOOKING,
  DELETE_USER,
  ENABLE_DISBLED_USER,
  GET_USER,
  PAST_BOOKING,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getUser = () => {
  return instance.get(GET_USER);
};

const enableDisbledUser = (data) => {
  return instance.put(ENABLE_DISBLED_USER, {
    status: data?.status,
    userId: data?._id,
  });
};

const deleteUser = (id) => {
  return instance.put(`${DELETE_USER}${id}`);
};

const currentBooking = (id) => {
  return instance.get(CURRENT_BOOKING + id);
};
const pastBooking = (id) => {
  return instance.get(PAST_BOOKING + id);
};

const userService = {
  getUser,
  enableDisbledUser,
  deleteUser,
  currentBooking,
  pastBooking,
};

export default userService;
